export default __webpack_public_path__ + "static/media/kakaopay.6779b605.png";